var map = {
	"./gt3-full_da": [
		667,
		45
	],
	"./gt3-full_da.json": [
		667,
		45
	],
	"./gt3-full_de": [
		668,
		46
	],
	"./gt3-full_de.json": [
		668,
		46
	],
	"./gt3-full_en": [
		669,
		47
	],
	"./gt3-full_en.json": [
		669,
		47
	],
	"./gt3-full_fo": [
		670,
		48
	],
	"./gt3-full_fo.json": [
		670,
		48
	],
	"./gt3-full_no": [
		671,
		49
	],
	"./gt3-full_no.json": [
		671,
		49
	],
	"./gt3_da": [
		672,
		50
	],
	"./gt3_da.json": [
		672,
		50
	],
	"./gt3_de": [
		673,
		51
	],
	"./gt3_de.json": [
		673,
		51
	],
	"./gt3_en": [
		674,
		52
	],
	"./gt3_en.json": [
		674,
		52
	],
	"./gt3_fo": [
		675,
		53
	],
	"./gt3_fo.json": [
		675,
		53
	],
	"./gt3_no": [
		676,
		54
	],
	"./gt3_no.json": [
		676,
		54
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1057;
module.exports = webpackAsyncContext;